import { useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import Col from 'react-bootstrap/Col';
import { useParams } from 'react-router-dom';

import { useComponentWillUnmount } from '../../core/hooks';
import FormPage from '../../core/containers/FormPage';
import { VehicleOwners } from './VehicleOwners';
import { vehicleActions } from '../store/vehicleStore';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
// interface VehiclePageProps {
//   data?: object
// }

const VehiclePage = props => {
  const [activeTab, setActiveTab] = useState('owners'); // тут будем фиксировать активный таб, чтобы при рендере лишние Табы не дергать

  const params = useParams();
  const vehicleId = params?.id;

  useComponentWillUnmount(() => {
    vehicleActions.clearVehicleOwners();
  });

  return (
    <FormPage
      header='Просмотр автомобиля '
    >
      <Tab.Container
        defaultActiveKey='owners'
        id='client-tabs'
        onSelect={ (firstTab) => {
          setActiveTab(firstTab);
        } }
      >
        <Nav className='nav-tabs'>
          <Nav.Item>
            <Nav.Link eventKey='owners'>Владельцы авто</Nav.Link>
          </Nav.Item>
        </Nav>

        <Tab.Content>
          { activeTab === 'owners' && (
            <Tab.Pane eventKey='owners'>
              <Col md={ 12 }>
                <VehicleOwners vehicleId={ vehicleId } />
              </Col>
            </Tab.Pane>
          ) }
        </Tab.Content>

      </Tab.Container>
    </FormPage>
  );
};

export default VehiclePage;
